module.exports = __webpack_public_path__ + "img/59554F_171716_847C74_2C2C24-256px.de702e21.png";